module.exports = fox._r("images/unlike.gif", __webpack_public_path__ + "images/unlike.gif");


//////////////////
// WEBPACK FOOTER
// ./images/unlike.gif
// module id = 1135
// module chunks = 4